var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.421,
    height: 15.385,
    viewBox: "0 0 19.421 15.385",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165",
    transform: "translate(-6006.713 -2126.945)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(6006.713 2126.945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6431",
    "data-name": "Path 6431",
    d: "M6006.713,2262.676c.024-.049.046-.1.073-.147q1.447-2.588,2.893-5.177a.553.553,0,0,1,.541-.325c1.462.008,2.924.005,4.387,0a.251.251,0,0,1,.247.139q.568.965,1.145,1.925a.485.485,0,0,0,.656.26.735.735,0,0,0,.288-.282c.358-.589.71-1.183,1.05-1.783a.442.442,0,0,1,.445-.262c1.441.012,2.883.008,4.325.005a.459.459,0,0,1,.452.26q.193.37.4.731c.068.118.032.159-.087.19q-1.262.333-2.522.673l-5.579,1.495c-.408.109-.816.215-1.222.331a.229.229,0,0,1-.276-.091c-.68-.82-1.363-1.638-2.056-2.448a.917.917,0,0,0-.386-.259.462.462,0,0,0-.527.228.508.508,0,0,0,.067.577c.378.455.76.908,1.14,1.362l.8.961-6.227,1.678Z",
    transform: "translate(-6006.713 -2247.646)",
    fill: "#cc0e2d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6432",
    "data-name": "Path 6432",
    d: "M6094.267,2130.46a3.449,3.449,0,0,1,2.881-3.468,3.441,3.441,0,0,1,3.906,4.119,4.953,4.953,0,0,1-.667,1.5l-2.283,3.942c-.031.053-.062.107-.1.158a.332.332,0,0,1-.6,0c-.179-.283-.343-.574-.512-.864-.617-1.058-1.238-2.114-1.849-3.176a5.11,5.11,0,0,1-.723-1.712C6094.3,2130.8,6094.286,2130.629,6094.267,2130.46Zm3.438,1.207a1.365,1.365,0,1,0-1.368-1.349A1.373,1.373,0,0,0,6097.706,2131.667Z",
    transform: "translate(-6087.954 -2126.945)",
    fill: "#cc0e2d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6433",
    "data-name": "Path 6433",
    d: "M6058.146,2286.662c.1-.034.175-.06.249-.08,1.233-.332,2.466-.661,3.7-1a.164.164,0,0,1,.222.094c.588,1.063,1.17,2.13,1.779,3.181a.414.414,0,0,1-.4.661c-.721-.01-1.441,0-2.163,0h-13.67a.28.28,0,0,1-.159-.041c.054-.019.106-.042.161-.057l3.952-1.064q2.55-.685,5.1-1.373a.208.208,0,0,1,.251.077q.737.884,1.481,1.76a.5.5,0,0,0,.714.08.519.519,0,0,0,.049-.724c-.378-.455-.762-.906-1.144-1.359C6058.237,2286.774,6058.2,2286.731,6058.146,2286.662Z",
    transform: "translate(-6044.751 -2274.136)",
    fill: "#cc0e2d",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.5b1ff21e68cdf7c18e5d99e0d7058c54.svg";
export { ForwardRef as ReactComponent };